import React, { Fragment } from 'react';
import PinderLikedUserCard from 'components/BriefDetailsClient/PitchBox/PinderLikedUserCard';
import PropTypes from 'prop-types';

const PinderLikedUserCardList = ({
  pitchListProps,
  pitches,
  preferredRole,
  userCardRef,
}) => {
  return (
    <Fragment>
      {pitches.map((pitch) => {
        return (
          <PinderLikedUserCard
            key={`PinderLikedUserCardList-PinderLikedUserCard-${pitch.id}`}
            pitch={pitch}
            pitchListProps={pitchListProps}
            userCardRef={userCardRef}
            preferredRole={preferredRole}
          />
        );
      })}
    </Fragment>
  );
};

PinderLikedUserCardList.propTypes = {
  pitches: PropTypes.array,
  pitchListProps: PropTypes.object,
  preferredRole: PropTypes.string,
};

export default PinderLikedUserCardList;
